import {
  API_ENDPOINTS,
  ApiResponse,
  MasterUserAdmin,
  CreateMasterUserAdminDto,
  UpdateMasterUserAdminDto,
  EmplecResponse
} from '../api';
import httpClient from '../httpClient';

export const masterUserAdminService = {
  getList: async (params?: { search?: string; page?: number; limit?: number }) => {
    try {
      const response = await httpClient.get<ApiResponse<MasterUserAdmin[]>>(
        API_ENDPOINTS.MASTER_USER_ADMIN.LIST,
        {
          params: {
            pageNumber: params?.page || 1,
            pageSize: params?.limit || 100,
            search: params?.search || ''
          }
        }
      );
      return response.data;
    } catch {
      return {
        pageNumber: params?.page || 1,
        pageSize: params?.limit || 100,
        totalPages: 0,
        totalRecords: 0,
        message: 'Failed to fetch data',
        data: []
      };
    }
  },

  getDetail: async (id: string) => {
    const response = await httpClient.get(API_ENDPOINTS.MASTER_USER_ADMIN.DETAIL(id));
    return response.data;
  },

  create: async (data: CreateMasterUserAdminDto) => {
    const response = await httpClient.post(API_ENDPOINTS.MASTER_USER_ADMIN.CREATE, data);
    return response.data;
  },

  update: async (data: UpdateMasterUserAdminDto) => {
    const response = await httpClient.put(API_ENDPOINTS.MASTER_USER_ADMIN.UPDATE, data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await httpClient.delete(API_ENDPOINTS.MASTER_USER_ADMIN.DELETE, {
      data: { msUserAdminId: id }
    });
    return response.data;
  },

  getEmplecList: async (params: { search: string; isEmployee: boolean; isLecturer: boolean }) => {
    const response = await httpClient.get<EmplecResponse>(API_ENDPOINTS.DATA_BINUS.EMPLEC_LIST, {
      params
    });
    return response.data;
  }
};
